import React from "react";
import { toast } from "react-toastify";
import styles from "./styles.scss";
import { FaCheckSquare, FaExclamationTriangle } from "react-icons/fa"

const Toaster = {
  // Keep the signature of the original toast object
  // Doing so you can pass additionnal options
  success(msg, options = {}) {
    var content = (
      <span id="user-message">
        <FaCheckSquare className={styles["icon-success"]} /> {msg}
      </span>
    );
    return toast.success(content, {
      ...options,
      className: styles["success"]
    });
  },

  error(msg, options = {}) {
    var content = (
      <span>
        <FaExclamationTriangle className={styles["icon-error"]} /> {msg}
      </span>
    );
    return toast.error(content, {
      ...options,
      className: styles["error"]
    });
  }
};

export default Toaster;
